import type React from "react";

import {usePlayerActions} from "~/hooks/usePlayerActions";

import useZoomControls from "../../../../hooks/useZoomControls";
import {useHotkeyManager} from "../hooks/useHotkeyManager";
import useLoadCurrentWipLevel from "../hooks/useLoadCurrentWipLevel";
import PlayTestLevel from "./PlayTestLevel";

const PlayTestLevelWrapper: React.FC = () => {
  useHotkeyManager();
  useLoadCurrentWipLevel();
  useZoomControls();
  usePlayerActions();

  return <PlayTestLevel />;
};

export default PlayTestLevelWrapper;
